import React from 'react';
import { BookOpen, Sparkles, Check } from 'lucide-react';
import Reveal from './Reveal';

export default function Recipes({ t }) {
  const r = t.recipes;

  return (
    <section className="relative bg-abyss py-24 lg:py-32 overflow-hidden">
      <div className="absolute -bottom-24 right-0 w-[440px] h-[440px] rounded-full bg-volt-400/8 blur-[150px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full border border-volt-400/40 bg-volt-400/10 text-volt-400 text-xs font-bold uppercase tracking-[0.18em] mb-5">
              {r.kicker}
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-frost tracking-tight leading-tight">
              {r.title}
            </h2>
            <p className="mt-5 text-lg text-mist leading-relaxed">{r.sub}</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Library card */}
          <Reveal>
            <div className="h-full rounded-3xl border border-line bg-surface p-8 lg:p-10 hover:border-volt-400/30 transition-colors duration-300">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-12 h-12 rounded-2xl bg-volt-400 flex items-center justify-center shadow-volt-glow">
                  <BookOpen size={22} className="text-ink" />
                </div>
                <h3 className="font-display text-2xl font-bold text-frost">{r.libraryTitle}</h3>
              </div>
              <ul className="flex flex-col gap-4">
                {r.library.map((item) => (
                  <li
                    key={item}
                    className="flex items-center gap-3 rounded-2xl border border-line bg-ink/50 px-5 py-4 text-frost/90 font-medium hover:border-volt-400/40 hover:translate-x-1 transition-all duration-200"
                  >
                    <span className="w-2 h-2 rounded-full bg-volt-400 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* Generated output card */}
          <Reveal delay={120}>
            <div className="h-full rounded-3xl border border-pulse-400/30 bg-gradient-to-br from-surface to-ink p-8 lg:p-10 hover:border-pulse-400/50 transition-colors duration-300">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-12 h-12 rounded-2xl bg-pulse-500 flex items-center justify-center">
                  <Sparkles size={22} className="text-white" />
                </div>
                <h3 className="font-display text-2xl font-bold text-frost">{r.outputTitle}</h3>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {r.output.map((item) => (
                  <div
                    key={item}
                    className="flex items-center gap-3 rounded-2xl border border-line bg-ink/50 px-5 py-4 hover:border-pulse-400/40 transition-colors duration-200"
                  >
                    <span className="w-6 h-6 rounded-full bg-pulse-500/20 border border-pulse-400/40 flex items-center justify-center shrink-0">
                      <Check size={12} className="text-pulse-400" strokeWidth={3} />
                    </span>
                    <span className="text-sm font-medium text-frost/90">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
